import { useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  InitConfirmApproveTerminationRequest,
  InitConfirmOperationResponse,
  initConfirmOperationResponseSchema,
} from '../../../common/validations'
import { ResidentAppError } from '../../../common/error'

import { post } from 'api/apiClient'
import { rethrowIdentificationRequired } from 'utils/rethrowIdentificationRequired'

type ContractChange = 'contract-termination' | 'contract-modification'

export const useAPIConfirmApproveContractChange = (
  contractUUID: string,
  locale: string,
  contractChange: ContractChange
) => {
  const { mutate, isSuccess, isError, error, data, isPending } = useMutation<
    InitConfirmOperationResponse,
    ErrorResponse,
    Omit<InitConfirmApproveTerminationRequest, 'locale'>
  >({
    mutationFn: ({ operationData, operationType }) =>
      post(
        `${API_ENDPOINTS.CONTRACTS}/${contractUUID}/confirm-operation/init/${contractChange}/approve`,
        {
          operationData,
          operationType,
          locale,
        },
        initConfirmOperationResponseSchema
      ),
  })

  if (isError) {
    rethrowIdentificationRequired(error)

    throw ResidentAppError.ClientError('CONFIRM_OPERATION_GENERIC_ERROR')
  }

  return {
    mutate,
    isSuccess,
    data,
    isPending,
  }
}
